import * as React from 'react';
import * as style from './style.css';
import { UIHeading1, UIText1 } from '@cian/ui-kit';

interface IPriceBlockProps {
  priceRelevance: React.ReactElement<any>;
  callButton: React.ReactElement<any>;
  priceForObject?: string;
  priceForMeter?: string;
  hasContacts: boolean;
}

export const PriceBlock = ({
  priceRelevance,
  priceForObject,
  priceForMeter,
  callButton,
  hasContacts,
}: IPriceBlockProps) => {
  return (
    <div className={style['container']} data-testid="PriceBlock">
      <div className={style['price-info']}>
        {priceRelevance}
        {!!priceForObject && <UIHeading1>{priceForObject}</UIHeading1>}
        {!!priceForMeter && <UIText1>{priceForMeter}</UIText1>}
      </div>
      {hasContacts && callButton}
    </div>
  );
};
